<template>
    <page :tabs="tabs" :busy="busy">
        <router-view @handleBusy="handleBusy"></router-view>
    </page>
</template>

<script>
import { formatResponseError } from '../../utils/api';
import page from '../generic/page/page.vue';
import { mapGetters } from 'vuex';

export default {
    name: "PropertyManager",
    components: {
        page
    },

    data() {
        return {
            busy: false,
        }
    },
    computed: {
        ...mapGetters('propertyManager', ['metadata']),
        tabs() {
            const tabs = [
                {
                    title: "Reservation Deposit",
                    route: "/app/property-manager/reservation-deposit/",
                    active: this.$route.path === "/app/property-manager/reservation-deposit/",
                },
                {
                    title: "Security Deposit",
                    route: "/app/property-manager/security-deposit/",
                    active: this.$route.path === "/app/property-manager/security-deposit/",
                },
                {
                    title: "Taxes",
                    route: "/app/property-manager/tax/",
                    active: this.$route.path === "/app/property-manager/tax/",
                },
                {
                    title: "Fees",
                    route: "/app/property-manager/fee/",
                    active: this.$route.path === "/app/property-manager/fee/",
                },
                {
                    title: "Services",
                    route: "/app/property-manager/service/",
                    active: this.$route.path === "/app/property-manager/service/",
                },
                {
                    title: 'Discount',
                    route: '/app/property-manager/discount/',
                    active: this.$route.path === '/app/property-manager/discount/',
                },

            ]
            if (this.metadata?.allow_insurances) {
                tabs.push({
                    title: 'Damage Protection',
                    route: '/app/property-manager/damage/',
                    active: this.$route.path === '/app/property-manager/damage/',
                })
            }
            return tabs
        },
    },

    mounted() {
        this.fetchMetadata()
    },
    methods: {
        handleBusy(value) {
            this.busy = value;
        },
        async fetchMetadata() {
            try {
                this.handleBusy(true)
                await this.$store.dispatch('propertyManager/fetchMetadata')
            } catch (e) {
                const { generic } = formatResponseError(e)
                this.errorToast({ text: generic || 'Could not fetch metadata' })
            } finally {
                this.handleBusy(false)
            }
        }
    }
}

</script>


<style lang="scss">
.filter-dropdown {
    a.dropdown-item {
        display: flex;
    }
}
</style>
